import KEstimatedTripDetails from "../Trips/KEstimatedTripDetails";
import { KAddressField, KTextField } from "kinnect-general";
import {
	VBtn,
	VCol,
	VIcon,
	VRow,
	VStepper,
	VStepperContent,
	VStepperStep
} from "vuetify/lib";

export default {
	name: "KTripCostEstimator",

	data: () => ( {
		endLocation: {
			loadingTime: null,
			location: {
				lat: 36.115717,
				lng: -97.0498469
			},
			name: "Kinnunen Sales and Rental"
		},
		startLocation: {
			loadingTime: null,
			location: {
				lat: 36.115717,
				lng: -97.0498469
			},
			name: "Kinnunen Sales and Rental"
		},
		stopLocations: []
	} ),

	computed: {
		startStepEl() {
			return [
				<VStepperStep editable step="S">
					Start Location {this.startLocation.name ? `: ${this.startLocation.name}` : null}
				</VStepperStep>,

				<VStepperContent step="S">
					<KAddressField
						label="Start Location"
						onPlacechanged={val => this.startLocation.location = {
							lat: val.latitude,
							lng: val.longitude
						}}
						vModel={this.startLocation.name}
					></KAddressField>

					<KTextField
						label="Loading Time"
						min="0"
						onInput={val => this.startLocation.loadingTime = parseFloat( val || 0 )}
						prependIcon="timer"
						step="5"
						suffix="minutes"
						type="number"
						value={this.startLocation.loadingTime}
					></KTextField>
				</VStepperContent>
			];
		},

		endStepEl() {
			return [
				<VStepperStep editable step="E">
					End Location {this.endLocation.name ? `: ${this.endLocation.name}` : null}
				</VStepperStep>,

				<VStepperContent step="E">
					<KAddressField
						label="End Location"
						onPlacechanged={val => this.endLocation.location = {
							lat: val.latitude,
							lng: val.longitude
						}}
						vModel={this.endLocation.name}
					></KAddressField>

					<KTextField
						label="Loading Time"
						min="0"
						onInput={val => this.endLocation.loadingTime = parseFloat( val || 0 )}
						prependIcon="timer"
						step="5"
						suffix="minutes"
						type="number"
						value={this.endLocation.loadingTime}
					></KTextField>
				</VStepperContent>
			];
		},

		stopStepEls() {
			return this.stopLocations.map( ( stop, i ) => {
				const stopNum = i + 1;

				return [
					<VStepperStep editable key={`stop-${stopNum}-header`} step={`S${stopNum}`}>
						Stop {stopNum} {stop.name ? `: ${stop.name}` : null}
					</VStepperStep>,

					<VStepperContent key={`stop-${stopNum}-content`} step={`S${stopNum}`}>
						<KAddressField
							onPlacechanged={val => stop.location = {
								lat: val.latitude,
								lng: val.longitude
							}}
							vModel={stop.name}
						></KAddressField>

						<KTextField
							label="Loading Time"
							min="0"
							onInput={val => stop.loadingTime = parseFloat( val || 0 )}
							prependIcon="timer"
							step="5"
							suffix="minutes"
							type="number"
							value={stop.loadingTime}
						></KTextField>

						<VBtn color="error" onClick={() => this.removeStop( i )}>
							<VIcon left>close</VIcon> Remove stop
						</VBtn>
					</VStepperContent>
				];
			} );
		},

		startLoadingTime() {
			return parseFloat( this.startLocation.loadingTime || 0 );
		},

		endLoadingTime() {
			return parseFloat( this.endLocation.loadingTime || 0 );
		},

		stopsLoadingTime() {
			return this.stopLocations.reduce( ( loadingTime, location ) => {
				loadingTime += parseFloat( location.loadingTime || 0 );

				return loadingTime;
			}, 0 );
		},

		loadingTimeSeconds() {
			return 60 * ( this.startLoadingTime + this.stopsLoadingTime + this.endLoadingTime );
		},

		waypoints() {
			return this.stopLocations.reduce( ( waypoints, stop ) => {
				if ( stop.location ) {
					waypoints.push( {
						lat: stop.location.lat,
						lng: stop.location.lng
					} );
				}

				return waypoints;
			}, [] );
		}
	},

	methods: {
		addStop() {
			this.stopLocations.push( {
				loadingTime: null,
				location: null,
				name: null
			} );
		},

		removeStop( index ) {
			this.stopLocations.splice( index, 1 );
		}
	},

	render() {
		return <div>
			<VRow>
				<VCol class="text-h4" cols={12}>
					Trip Cost Estimator
				</VCol>
			</VRow>

			<VRow>
				<VCol cols={12} sm={7} md={9}>
					<KEstimatedTripDetails
						endLatLng={this.endLocation.location}
						label="Estimated Details"
						latLngs={this.waypoints}
						loadTimeSeconds={this.loadingTimeSeconds}
						startLatLng={this.startLocation.location}
					></KEstimatedTripDetails>
				</VCol>

				<VCol cols={12} sm={5} md={3}>
					<VBtn large onClick={this.addStop} block>
						<VIcon left>add_circle</VIcon> Add Another Stop
					</VBtn>
				</VCol>
			</VRow>

			<VRow>
				<VCol cols={12}>
					<VStepper class="pa-0" nonLinear vertical>
						{this.startStepEl}
						{this.stopStepEls}
						{this.endStepEl}
					</VStepper>
				</VCol>
			</VRow>
		</div>;
	}
};
